import { Box, Container, Typography } from "@mui/material";

const NoResult = ({ checkFilter }: { checkFilter?: boolean }) => {
  return (
    <Box
      component="main"
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        minHeight: "100%",
        mt: 2,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            mb: 10,
          }}
        >
          <Box
            sx={{
              mb: 3,
              textAlign: "center",
            }}
          >
            <img
              alt="Under development"
              src="/assets/errors/no-result.png"
              style={{
                display: "inline-block",
                maxWidth: "100%",
                width: 200,
              }}
            />
          </Box>
          <Typography align="center" sx={{ mb: 3 }} variant="h5">
            Nessun risultato trovato...
          </Typography>

          {checkFilter && (
            <Typography align="center" color="text.secondary" variant="body1">
              Prova a modificare i filtri
            </Typography>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default NoResult;
